/* src/app/private/components/view/department-section/delete-department/delete-department.component.scss */
/*# sourceMappingURL=delete-department.component.css.map */
